<template>
  <g>
    <g transform="scale(0.8)">
      <text transform="matrix(1 0 0 1 65 40)" class="name1">LCD{{number}}</text>
      <path class="st0" d="M65.73,313.09c-4.41,0-8-3.59-8-8v-242c0-4.41,3.59-8,8-8h548c4.41,0,8,3.59,8,8v242c0,4.41-3.59,8-8,8H65.73z"
          />
      <g>
          <path class="st1" d="M613.73,310.09h-548c-2.76,0-5-2.24-5-5v-242c0-2.76,2.24-5,5-5h548c2.76,0,5,2.24,5,5v242
              C618.73,307.85,616.5,310.09,613.73,310.09z"/>
          <g>
              <circle class="st2" cx="76.73" cy="74.09" r="14.5"/>
              <circle class="st3" cx="76.73" cy="74.09" r="9.5"/>
          </g>
          <g>
              <path class="st2" d="M109.14,71.81c2.77,0,5.06-2.05,5.44-4.72h0.06v-9h-11v9h0.06C104.08,69.76,106.37,71.81,109.14,71.81z"/>
              <circle class="st3" cx="109.14" cy="66.31" r="3.05"/>
          </g>
          <g>
              <circle class="st2" cx="602.73" cy="74.09" r="14.5"/>
              <circle class="st3" cx="602.73" cy="74.09" r="9.5"/>
          </g>
          <g>
              <circle class="st2" cx="76.73" cy="294.09" r="14.5"/>
              <circle class="st3" cx="76.73" cy="294.09" r="9.5"/>
          </g>
          <g>
              <circle class="st2" cx="602.73" cy="294.09" r="14.5"/>
              <circle class="st3" cx="602.73" cy="294.09" r="9.5"/>
          </g>
          <text transform="matrix(6.123234e-17 1 -1 6.123234e-17 106.499 74.0067)" class="st3 st4 st5">GND</text>
          <g>
              <path class="st2" d="M126.87,71.81c2.77,0,5.06-2.05,5.44-4.72h0.06v-9h-11v9h0.06C121.81,69.76,124.1,71.81,126.87,71.81z"/>
              <circle class="st3" cx="126.87" cy="66.31" r="3.05"/>
          </g>
          <text transform="matrix(6.123234e-17 1 -1 6.123234e-17 124.2324 75.0067)" class="st3 st4 st5">YCC</text>
          <g>
              <path class="st2" d="M144.61,71.81c2.77,0,5.06-2.05,5.44-4.72h0.06v-9h-11v9h0.06C139.55,69.76,141.83,71.81,144.61,71.81z"/>
              <circle class="st3" cx="144.61" cy="66.31" r="3.05"/>
          </g>
          <text transform="matrix(6.123234e-17 1 -1 6.123234e-17 141.9658 75.0067)" class="st3 st4 st5">VO</text>
          <g>
              <path class="st2" d="M162.34,71.81c2.77,0,5.06-2.05,5.44-4.72h0.06v-9h-11v9h0.06C157.28,69.76,159.57,71.81,162.34,71.81z"/>
              <circle class="st3" cx="162.34" cy="66.31" r="3.05"/>
          </g>
          <text transform="matrix(6.123234e-17 1 -1 6.123234e-17 159.6992 74.0067)" class="st3 st4 st5">RS</text>
          <g>
              <path class="st2" d="M180.07,71.81c2.77,0,5.06-2.05,5.44-4.72h0.06v-9h-11v9h0.06C175.01,69.76,177.3,71.81,180.07,71.81z"/>
              <circle class="st3" cx="180.07" cy="66.31" r="3.05"/>
          </g>
          <text transform="matrix(6.123234e-17 1 -1 6.123234e-17 177.4326 74.0067)" class="st3 st4 st5">RW</text>
          <g>
              <path class="st2" d="M197.81,71.81c2.77,0,5.06-2.05,5.44-4.72h0.06v-9h-11v9h0.06C192.75,69.76,195.03,71.81,197.81,71.81z"/>
              <circle class="st3" cx="197.81" cy="66.31" r="3.05"/>
          </g>
          <text transform="matrix(6.123234e-17 1 -1 6.123234e-17 195.166 74.0067)" class="st3 st4 st5">E</text>
          <g>
              <path class="st2" d="M215.54,71.81c2.77,0,5.06-2.05,5.44-4.72h0.06v-9h-11v9h0.06C210.48,69.76,212.77,71.81,215.54,71.81z"/>
              <circle class="st3" cx="215.54" cy="66.31" r="3.05"/>
          </g>
          <text transform="matrix(6.123234e-17 1 -1 6.123234e-17 212.8994 74.0067)" class="st3 st4 st5">DB0</text>
          <g>
              <path class="st2" d="M233.27,71.81c2.77,0,5.06-2.05,5.44-4.72h0.06v-9h-11v9h0.06C228.21,69.76,230.5,71.81,233.27,71.81z"/>
              <circle class="st3" cx="233.27" cy="66.31" r="3.05"/>
          </g>
          <text transform="matrix(6.123234e-17 1 -1 6.123234e-17 230.6328 74.0067)" class="st3 st4 st5">DB1</text>
          <g>
              <path class="st2" d="M251.01,71.81c2.77,0,5.06-2.05,5.44-4.72h0.06v-9h-11v9h0.06C245.95,69.76,248.23,71.81,251.01,71.81z"/>
              <circle class="st3" cx="251.01" cy="66.31" r="3.05"/>
          </g>
          <text transform="matrix(6.123234e-17 1 -1 6.123234e-17 248.3652 74.0067)" class="st3 st4 st5">DB2</text>
          <g>
              <path class="st2" d="M268.74,71.81c2.77,0,5.06-2.05,5.44-4.72h0.06v-9h-11v9h0.06C263.68,69.76,265.97,71.81,268.74,71.81z"/>
              <circle class="st3" cx="268.74" cy="66.31" r="3.05"/>
          </g>
          <text transform="matrix(6.123234e-17 1 -1 6.123234e-17 266.0996 74.0067)" class="st3 st4 st5">DB3</text>
          <g>
              <path class="st2" d="M286.47,71.81c2.77,0,5.06-2.05,5.44-4.72h0.06v-9h-11v9h0.06C281.41,69.76,283.7,71.81,286.47,71.81z"/>
              <circle class="st3" cx="286.47" cy="66.31" r="3.05"/>
          </g>
          <text transform="matrix(6.123234e-17 1 -1 6.123234e-17 283.832 74.0067)" class="st3 st4 st5">DB4</text>
          <g>
              <path class="st2" d="M304.21,71.81c2.77,0,5.06-2.05,5.44-4.72h0.06v-9h-11v9h0.06C299.15,69.76,301.43,71.81,304.21,71.81z"/>
              <circle class="st3" cx="304.21" cy="66.31" r="3.05"/>
          </g>
          <text transform="matrix(6.123234e-17 1 -1 6.123234e-17 301.5664 74.0067)" class="st3 st4 st5">DB5</text>
          <g>
              <path class="st2" d="M321.94,71.81c2.77,0,5.06-2.05,5.44-4.72h0.06v-9h-11v9h0.06C316.88,69.76,319.17,71.81,321.94,71.81z"/>
              <circle class="st3" cx="321.94" cy="66.31" r="3.05"/>
          </g>
          <text transform="matrix(6.123234e-17 1 -1 6.123234e-17 319.2988 74.0067)" class="st3 st4 st5">DB6</text>
          <g>
              <path class="st2" d="M339.67,71.81c2.77,0,5.06-2.05,5.44-4.72h0.06v-9h-11v9h0.06C334.61,69.76,336.9,71.81,339.67,71.81z"/>
              <circle class="st3" cx="339.67" cy="66.31" r="3.05"/>
          </g>
          <text transform="matrix(6.123234e-17 1 -1 6.123234e-17 337.0332 74.0067)" class="st3 st4 st5">DB7</text>
          <g>
              <path class="st2" d="M357.41,71.81c2.77,0,5.06-2.05,5.44-4.72h0.06v-9h-11v9h0.06C352.35,69.76,354.63,71.81,357.41,71.81z"/>
              <circle class="st3" cx="357.41" cy="66.31" r="3.05"/>
          </g>
          <text transform="matrix(6.123234e-17 1 -1 6.123234e-17 354.7656 75.0067)" class="st3 st4 st5">LED</text>
          <g>
              <path class="st2" d="M375.14,71.81c2.77,0,5.06-2.05,5.44-4.72h0.06v-9h-11v9h0.06C370.08,69.76,372.37,71.81,375.14,71.81z"/>
              <circle class="st3" cx="375.14" cy="66.31" r="3.05"/>
          </g>
          <text transform="matrix(6.123234e-17 1 -1 6.123234e-17 372.5 75.0067)" class="st3 st4 st5">LED</text>
      </g>
      <path class="st6" d="M583.73,272.09h-488c-2.76,0-5-2.24-5-5v-166c0-2.76,2.24-5,5-5h488c2.76,0,5,2.24,5,5v166
          C588.73,269.85,586.5,272.09,583.73,272.09z"/>
      <path class="st7" d="M565.23,240.59h-451c-2.76,0-5-2.24-5-5v-103c0-2.76,2.24-5,5-5h451c2.76,0,5,2.24,5,5v103
          C570.23,238.35,568,240.59,565.23,240.59z"/>
      <g id="text-display">
        <text transform="matrix(1 0 0 1 120 170)" class="text upper"></text>
        <text transform="matrix(1 0 0 1 120 220)" class="text lower"></text>
      </g>
      <g>
          <g class="pin">
              <rect x="65" y="100" width="16" height="16" class="st8"/>
              <text transform="matrix(1 0 0 1 68 128)" class="name">GND</text>
              <rect :id="`${pincode}MS`" @click="onClick(`${pincode}MS`)" class="pin-cover terminal" x="65" y="100" width="18" height="18"></rect>
          </g>
          <g class="pin">
              <rect x="65" y="130" width="16" height="16" class="st8"/>
              <text transform="matrix(1 0 0 1 68 158)" class="name">VCC</text>
              <rect :id="`${pincode}PS`" @click="onClick(`${pincode}PS`)" class="pin-cover terminal" x="65" y="130" width="18" height="18"></rect>
          </g>
          <g class="pin">
              <rect x="65" y="160" width="16" height="16" class="st8"/>
              <text transform="matrix(1 0 0 1 68 188)" class="name">SDA</text>
              <rect :id="`${pincode}CD`" @click="onClick(`${pincode}CD`)" class="pin-cover terminal" x="65" y="160" width="18" height="18"></rect>
          </g>
          <g class="pin">
              <rect x="65" y="190" width="16" height="16" class="st8"/>
              <text transform="matrix(1 0 0 1 68 218)" class="name">SCL</text>
              <rect :id="`${pincode}CL`" @click="onClick(`${pincode}CL`)" class="pin-cover terminal" x="65" y="190" width="18" height="18"></rect>
          </g>
      </g>
    </g>
  </g>
</template>

<script>
import store from '../../../../store/index.js'
import { pins } from '../../../../mixins/pin-util.js'

export default {
  props: ['data'],
  mixins: [pins],
  name: 'LCD',
  data () {
    return {
      on: false,
      socket: null,
      contents: ['', ''],
      cursor: {
        col: 0,
        row: 1
      }
    }
  },
  mounted () {
    this.setPindata(this.data)
  },
  methods: {
    onClick (pin) {
      const name = this.data.id
      store.commit('wire/createLines', { name, pin })
      window.event.stopPropagation()
    },
    displayText (pos) {
      if (this.on) {
        let temp = this.contents
        if (this.cursor.col !== 0) {
          let space = ''
          for (let i = 0; i < this.cursor.col; i++) {
            space += '\u00A0'
          }
          temp = space + temp
        }
        let col = 0
        if (pos === this.cursor.row) {
          col = this.cursor.col
        }
        return temp.substr(0 + 16 * pos, 16 - col)
      } else {
        return ''
      }
    },
    start (socket) {
      this.socket = socket
      this.on = true
      this.socket.onmessage = ({ data }) => {
        data = JSON.parse(data)
        this.contents[0] = JSON.stringify(data.value[0]).replace(/ /g, '&nbsp')
        this.contents[1] = JSON.stringify(data.value[1]).replace(/ /g, '&nbsp')
        document.querySelector('text.upper').innerHTML = this.contents[0]
        document.querySelector('text.lower').innerHTML = this.contents[1]
      }
    },
    off () {
      this.on = false
      this.socket = null
      this.contents[0] = ''
      this.contents[1] = ''
      document.querySelector('text.upper').innerHTML = ''
      document.querySelector('text.lower').innerHTML = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.pin-cover{
  display: block;
  stroke: none;
  fill: none;
}

.pin:hover{
  cursor: pointer;
  .pin-cover{
    stroke-width: 3px;
    stroke: black;
    fill: #ff6f61;
 }
}
.selected{
  & path.st0{
    display: block;
    fill: #ff6f61;
  }
}
.st8{
    stroke-width: 3px;
    stroke: #514E55;
}
.st0{fill:#D6D6D6; display: none;}
.st1{fill:#367729;}
.st2{fill:#A07C28;}
.st3{fill:#FFFFFF;}
.st4{font-family:'MyriadPro-Regular';}
.st5{font-size:9px;}
.st6{fill:#271D17;}
.st7{fill:#2E66E3;}
.name{fill: white; font-size: 0.5rem;}
.name1{fill:black; font-size: 26px;}
#text-display{
    text{
        font-size: 40px;
        fill: white;
    }
}
</style>
